import { useState } from "react";

import { MobileFiltersBottomSheet } from "../../Common/controls/MobileFiltersBottomSheet";
import { useClientFundedNotTradedReportContext } from "../providers/ClientFundedNotTradedProvider";

type MobileFiltersV2Props = {
  handleSearchInput: (value: string) => void;
};

export const MobileFiltersV2 = ({
  handleSearchInput,
}: MobileFiltersV2Props) => {
  const {
    state: {
      searchQuery,
      selected: { rebateAccountIDs: selectedRebateAccountIDs },
    },
    options: { rebateAccountIDs },
    actions,
  } = useClientFundedNotTradedReportContext();

  const [selectedDateOption, setSelectedDateOption] = useState("last30days");

  const handleApply = (params: {
    dateOption: string;
    dateRange: { from: Date; to: Date };
    rebateAccountIDs: string[];
  }) => {
    setSelectedDateOption(params.dateOption);
    actions.setDateRange(params.dateRange);
    actions.setSelected("rebateAccountIDs", params.rebateAccountIDs);
  };

  const handleReset = () => {
    const today = new Date();
    const start = new Date(today);
    start.setDate(start.getDate() - 30);

    actions.setDateRange({ from: start, to: today });
    actions.setSelected(
      "rebateAccountIDs",
      rebateAccountIDs.map((a) => a.value),
    );
    setSelectedDateOption("last30days");
  };

  return (
    <div className="sticky top-[64px] z-10 mt-6 bg-surface-primary pb-4 pt-4">
      <MobileFiltersBottomSheet
        handleSearchInput={handleSearchInput}
        canViewPII={false}
        searchQuery={searchQuery}
        rebateAccountOptions={rebateAccountIDs}
        selectedRebateAccountIDs={selectedRebateAccountIDs as string[]}
        selectedDateOption={selectedDateOption}
        containerClassName="flex flex-row items-center gap-2"
        onApply={handleApply}
        onReset={handleReset}
      />
    </div>
  );
};
